var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"cancelFunction":_vm.closeModal,"okFunction":_vm.deleteApperanceScheme,"title":"Delete Confirmation"},scopedSlots:_vm._u([{key:"body",fn:function(){return [_vm._v(" Are you sure you want to delete this scheme? ")]},proxy:true}])})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }